import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BnLoadingService } from '@bndes/bndes-ux4/bndes-angular-utils';
import { ExportacaoAgenteFinanceiroService } from '../../exportacao/exportacao-agente-financeiro.service';
import { ExportacaoGestorService } from '../../exportacao/exportacao-gestor.service';
import { RetornoMensagemSimplesDTO } from 'src/app/model/questionario.model';
import { MensagemService } from '../../mensagem.service';

@Component({
  selector: 'app-acomp-metas-distribuicao-limites',
  templateUrl: './acomp-metas-distribuicao-limites.component.html',
  styleUrls: ['./acomp-metas-distribuicao-limites.component.scss'],
  standalone: false,
})
export class AcompMetasDistribuicaoLimitesComponent implements OnInit {
  public analitico = false;
  public sintetico = true;
  private ehGestor = false;

  constructor(
    private exportacaoAgenteService: ExportacaoAgenteFinanceiroService,
    private exportacaoGestorService: ExportacaoGestorService,
    private loadingService: BnLoadingService,
    private mesangemService: MensagemService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
     this.ehGestor = this.route.snapshot.data['perfil'] === 'gestor';
  }

  public selecionarAnalitico() {
    this.analitico = true;
    this.sintetico = false;
  }

  public selecionarSintetico() {
    this.sintetico = true;
    this.analitico = false;
  }

  public get podeEmitir(): boolean {
    return this.analitico || this.sintetico;
  }

  public emitir() {
    if (!this.podeEmitir) {
      return;
    }

    const tipo: 'analitico' | 'sintetico' =
      this.analitico ? 'analitico' : 'sintetico';

    this.loadingService.bloqueiaTela();

    if (this.ehGestor) {
      this.exportacaoGestorService.emitirAcompanhamentoMetasDistribuicaoLimites(tipo).subscribe({
        next: (retorno : RetornoMensagemSimplesDTO) => {
          console.log('Retorno: ', retorno);
          this.loadingService.liberaTela();
          this.mesangemService.adicionarMensagemSucesso(retorno.mensagem);
        },
        error: () => {
          this.loadingService.liberaTela();
          this.mesangemService.adicionarMensagemErro('Não foi possível gerar relatório solicitado');
        },
      });
    } else {
      this.exportacaoAgenteService.emitirRelatorio(tipo).subscribe({
        next: (blob: Blob) => {
          const link = document.createElement('a');

          link.href = window.URL.createObjectURL(blob);
          link.download = `acompanhamento-metas-distribuicao-limites-${tipo}.csv`;

          link.click();

          window.URL.revokeObjectURL(link.href);

          this.loadingService.liberaTela();
        },
        error: () => this.loadingService.liberaTela(),
      });
    }
  }
}
